export default __webpack_public_path__ + "static/media/Charts.fba31d00.webp";